export class ValidationConstants {
    public static readonly NameMinLength: number = 2;
    public static readonly NameMaxLength: number = 45;

    public static readonly UserNameMinLength: number = 4;
    public static readonly UserNameMaxLength: number = 20;

    public static readonly EmailMinLength: number = 5;
    public static readonly EmailMaxLength: number = 255;
    
    public static readonly PasswordMinLength = 10;
    public static readonly PasswordMaxLength: number = 100;

    public static readonly MessageMinLength: number = 25;
    public static readonly MessageMaxLength: number = 1000;

    public static readonly PostalCodeMinLength: number = 6;
    public static readonly PostalCodeMaxLength: number = 6;

    public static readonly AddressMinLength: number = 2;
    public static readonly AddressMaxLength: number = 100;

    public static readonly CityMinLength: number = 2;
    public static readonly CityMaxLength: number = 100;

    public static readonly ProvinceMinLength: number = 2;
    public static readonly ProvinceMaxLength: number = 100;

    public static readonly PhoneMinLength: number = 10;
    public static readonly PhoneMaxLength: number = 15;

    public static readonly AgencyStatusMinLength: number = 2;
    public static readonly AgencyStatusMaxLength: number = 45;

    public static readonly AgencyNameMinLength: number = 2;
    public static readonly AgencyNameMaxLength: number = 100;

    public static readonly AgencyEmailMinLength: number = 6;
    public static readonly AgencyEmailMaxLength: number = 45;

    public static readonly URLMinLength: number = 1;
    public static readonly URLMaxLength: number = 2048;

    public static readonly TextboxMinLength: number = 10;
    public static readonly TextboxMaxLength: number = 2000;

    public static readonly PIN_MIN: number = 10_000;
    public static readonly PIN_MAX: number = 99_999;
    
    public static readonly BARCODE_MIN_LENGTH: number = 100_000;
    public static readonly BARCODE_MAX_LENGTH: number = 999_999;

    public static readonly BARCODE_LENGTH: number = 6;
    public static readonly PIN_LENGTH: number = 5;

    public static readonly REFERENCE_NUMBER_MIN_LENGTH: number = 9;
    public static readonly REFERENCE_NUMBER_MAX_LENGTH: number = 9;

    public static readonly WEIGHT_MIN: number = 1;
    public static readonly WEIGHT_MAX: number = 99999;

    //These are to lock down the frontend only. The backend does not have any validation for these values. Nor is it needed.
    public static readonly AGENCY_CONTACT_LIMIT: number = 5;
    public static readonly AGENCY_QR_CODE_LIMIT: number = 100;

    //This is used to allow transaction functionality without the need to affect any real product types
    public static readonly HIDDEN_PRODUCT_TYPE: string = 'Hidden Type';

    public static readonly AlternativeNameMinLength: number = 3;
    public static readonly AlternativeNameMaxLength: number = 500;

    public static readonly MAX_MAILTO_LENGTH: number = 1500;

    public static generateRandomPin(): number {
        return Math.floor(Math.random() * (ValidationConstants.PIN_MAX - ValidationConstants.PIN_MIN + 1)) + ValidationConstants.PIN_MIN;
    }
}